import { useEffect, useState } from "react";
import EmployeeCard from "../../components/Reusable/EmployeeCard";

import EmployeeManagementTable from "./EmployeeManagementTable";
import useCompanyStore from "../../store/useCompanyStore";
import useSelectedCompanyStore from "../../store/useSelectedCompanyStore";
import EmployeeSearch from "./components/EmployeeSearch";
import EmployeeManagementHeader from "./components/EmployeeManagementHeader";

const EmployeeManagement = () => {
  const [empCard, setEmpCard] = useState(false);
  const [empTable, setEmpTable] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const [selectedFilter, setSelectedFilter] = useState("Sort By Name");
  const { companyList, fetchCompanies } = useCompanyStore();
  const { selectedCompany, setSelectedCompany } = useSelectedCompanyStore();

  useEffect(() => {
    fetchCompanies();
  }, []);

  const empCardButtonClick = () => {
    setEmpCard(true);
    setEmpTable(false);
  };

  const empTableButtonClick = () => {
    setEmpCard(false);
    setEmpTable(true);
  };

  const onCompanyChange = (e) => {
    if (!e.target.value) {
      setSelectedCompany(null);
      return;
    }
  };

  return (
    <div className="w-full pt-0 px-7 pb-12">
      <EmployeeManagementHeader
        companyList={companyList}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        onChange={onCompanyChange}
      />
      <div>
        <div className="flex h-20 items-center justify-between p-4 rounded-md bg-white">
          <div className="flex items-center justify-center">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center justify-between">
                <button
                  className={`flex justify-center items-center border-none w-10 h-10 text-[1.3rem] font-normal ${
                    empTable
                      ? "bg-[var(--secondary-color)] text-white"
                      : "bg-[var(--highlight-bg-color)] rounded-l-[5px]"
                  }`}
                  onClick={empTableButtonClick}
                >
                  <i className="ri-table-line"></i>
                </button>
                <button
                  className={`flex justify-center items-center border-none w-10 h-10 text-[1.3rem] font-normal ${
                    empCard
                      ? "bg-[var(--secondary-color)] text-white"
                      : "bg-[#f3f3f3] rounded-r-[8px]"
                  }`}
                  onClick={empCardButtonClick}
                >
                  <i className="ri-microsoft-fill"></i>
                </button>
              </div>
              <div>
                <EmployeeSearch
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-8 p-4">
          {empCard && (
            <EmployeeCard
              selectedCompany={selectedCompany?.name || ""}
              selectedFilter={selectedFilter}
              searchQuery={searchQuery}
            />
          )}
        </div>
        {empTable && (
          <EmployeeManagementTable
            selectedCompanyId={selectedCompany?.id}
            selectedCompany={selectedCompany?.name || ""}
            selectedFilter={selectedFilter}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        )}
      </div>
    </div>
  );
};

export default EmployeeManagement;
